export default __webpack_public_path__ + "static/media/icon.8869bea8.svg";